import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import LoadingScreen from "../LoadingScreen";
import { useSelector } from "react-redux";
const FUELTOPUPREASONS = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const userState = useSelector((state) => state.changeTheState.user);
  const LoggedInUserName = userState?.emailId?.split("@")[0].toUpperCase();
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);

  const [areadId, setAreaId] = useState("");
  const [areaName, setAreaName] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [searchArea, setSearchArea] = useState("");

  const [itemsList, setItemsList] = useState([]);
  const [accompList, setAccompList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [accompProductCode, setAccompProductCode] = useState("");
  const [accompProductName, setAccompProductName] = useState("");
  const [qty, setQty] = useState("");
  const [rate, setRate] = useState("");
  const [uom, setUom] = useState("");
  const [uomList, setUomList] = useState([]);
  const [accompanimentRows, setAccompanimentRows] = useState([]);

  const [topUpReason, setTopUpReason] = useState("");

  const filteredData = dataList?.filter((item) => {
    const searchData = searchArea?.toLowerCase()?.split(" ")?.filter(Boolean);
    const textMatch =
      searchData?.length === 0 ||
      searchData.every((term) => {
        return [
          "REASON",
        ].some((key) => {
          const columnValue = String(item[key])?.toLowerCase();
          return columnValue?.includes(term);
        });
      });
    return textMatch;
  });

  useEffect(() => {
    masterData();
  }, []);

  function masterData() {
    setisloading(true);
        axios
          .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1833`, {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          })
          .then((res) => {
            setDataList(res?.data)
            setisloading(false);
          })
          .catch((error) => {
            setisloading(false);
            console.error("Error fetching 1833:", error);
          });
  }

  // --- ADD ROW HANDLER ---
  function addAccompanimentRow() {
    if (!topUpReason) {
      alert("Kindly Supply Top Up Reason");
      return;
    }

    // prevent duplicate accompaniment item for same product
    // const alreadyExists = accompanimentRows.some(
    //   (row) => row.accompProductCode === accompProductCode,
    // );
    // if (alreadyExists) {
    //   alert("This Accompaniment Item is already added");
    //   return;
    // }

    setAccompanimentRows((prev) => [
      ...prev,
      {
        topUpReason: topUpReason,
      },
    ]);

    // clear temp fields for next entry
    setTopUpReason("");
  }

  function removeAccompanimentRow(index) {
    setAccompanimentRows((prev) => prev.filter((_, i) => i !== index));
  }

  async function submitCategory() {
    if (!productName) {
      alert("Kindly Supply Product");
      return;
    }

    if (accompanimentRows.length === 0) {
      alert("Kindly Add At Least One Item");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1815`,
        {
          PRODUCTCODE: productCode,
          DELETEDBY: LoggedInUserName || "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        try {
          const requests = accompanimentRows.map((row) =>
            axios.post(
              `${BASEURL_GLOBAL}/globalSpHandler?spname=1814`,
              {
                PRODUCTNAME: productName || "",
                PRODUCTCODE: productCode || "",
                RAWMATERIALCODE: row.accompProductCode || "",
                RAWMATERIALQTY: row.qty ? Number(row.qty) : 0,
                RAWMATERIALQTYUOM: row.uom || "",
                RAWMATERIALSTDRATE: row.rate ? Number(row.rate) : 0,
                RAWMATERIALSTDAMOUNT: row.amount ? Number(row.amount) : 0,
                CREATEDBY: LoggedInUserName || "",
                SUCCESS_STATUS: "",
                ERROR_STATUS: "",
              },
              {
                headers: {
                  "auth-token": authToken,
                  "session-token": sessiontoken,
                },
              },
            ),
          );

          const responses = await Promise.all(requests);

          const allSuccess = responses.every(
            (response) => response.status === 201,
          );

          if (allSuccess) {
            alert(`Recipe Master Saved successfully`);
            window.location.reload();
          } else {
            alert("Some Recipes failed to save");
            console.error("Error while Saving one or more Recipes");
            setisloading(false);
          }
        } catch (error) {
          console.log(error);
          alert(error?.response?.data?.message);
          setisloading(false);
          console.error(`Error while Saving Recipe`, error);
        }
      } else {
        console.error(`Error while Saving Recipe Master`);
        alert("Error while Saving Recipe Master");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      setisloading(false);
      console.error(`Error while Saving Recipe Master`, error);
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }
  return (
    <div>
      {" "}
      <>
        <AllPagesNavbar />
        <header className="header__of__main lg:flex  justify-between items-end px-3 ">
          <h1 className="header__of__page">FUEL TOP UP REASONS</h1>
          <div className="my-1">
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => {
                setTopUpReason("");
              }}
            >
              New
            </button>
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              //   onClick={() => submitCategory()}
            >
              Save
            </button>
          </div>
        </header>
        <div>
          <article>
            <section className=" shadow-slate-100	m-2 bg-gray-100 border-black rounded	p-2 ">
              <aside className="lg:flex lg:my-1 lg:mb-3">
                <p className="lg:ml-2">Top up reason :</p>
                <input
                  className="w-96 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={topUpReason}
                  onChange={(e) => setTopUpReason(e.target.value)}
                ></input>

                <button
                  className="bg-[#002d62] text-white rounded-md px-3 h-[30px] lg:ml-3"
                  onClick={addAccompanimentRow}
                >
                  Add
                </button>
              </aside>

              {/* --- LIST OF ADDED ACCOMPANIMENT ROWS BEFORE SAVE --- */}
              {accompanimentRows.length > 0 && (
                <section className="visible lg:h-[200px] lg:w-[700px] p-1 z-0 lg:overflow-auto mt-2">
                   <table className="w-full border border-gray-300 text-[10px] table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[10px] table-header">
                        <td className="py-1 px-2 text-left border border-gray-300">S No</td>
                        <td className="py-1 px-2 text-left border border-gray-300">Top Up Reason</td>
                        <td className="py-1 px-2 text-left border border-gray-300">Action</td>
                      </tr>
                    </thead>
                    <tbody>
                      {accompanimentRows.map((row, index) => (
                        <tr key={index}   className="hover:bg-gray-100 cursor-pointer text-[10px]">
                          <td className="py-1 px-2 text-right border border-gray-300">{index + 1}</td>
                          <td className="py-1 px-2 text-left border border-gray-300">{row.topUpReason}</td>
                          <td className="py-1 px-2 text-left border border-gray-300">
                            <button
                              className="text-red-600"
                              onClick={() => removeAccompanimentRow(index)}
                            >
                              <AiOutlineClose />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </section>
              )}
            </section>
          </article>
        </div>
        <section className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
          <div className="lg:flex items-center">
            <p className="lg:mx-2 text-[16px]">Search</p>
            <input
              className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              required
              value={searchArea}
              onChange={(e) => {
                setSearchArea(e.target.value);
              }}
            ></input>
          </div>

          <table className="w-full border border-gray-300 text-[10px] table_1">
            <thead className="sticky top-0">
              <tr className="bg-[#2b3f5c] text-white text-[10px] table-header">
                <td className="py-1 px-2 text-left border border-gray-300">
                  S No{" "}
                </td>
                <td className="py-1 px-2 text-left border border-gray-300">
                  TOP UP REASONS
                </td>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                filteredData.map((value, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-100 cursor-pointer text-[10px]"
                    onClick={() => {
                      setTopUpReason(value?.REASON);
                    }}
                  >
                    <td className="py-1 px-2 text-right border border-gray-300">
                      {index + 1}
                    </td>
                    <td className="py-1 px-2 text-left border border-gray-300">
                      {value.REASON ? value.REASON : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </>
    </div>
  );
};

export default FUELTOPUPREASONS;
